import { combineEpics } from 'uf/base/epics';
import layerNotifications from 'uf/layers/epics/notifications';

export default combineEpics(
  {
    layerNotifications,
  },
  'layer',
);
